var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccessory43(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 142,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-467 -426)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M619 462.674C613.928 445.558 598.281 433 579.541 433 565.674 433 553.444 439.846 545.944 450.332 538.444 439.846 526.214 433 512.348 433 489.507 433 471 451.539 471 474.421 471 477.664 471.414 480.799 472.115 483.826 477.636 518.148 514.344 554.019 542.419 566 574.361 537.173 600.529 502.095 619 462.674Z",
    fill: "#FFAC33",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649 471.543C649 448.594 630.356 430 607.345 430 593.376 430 581.055 436.867 573.5 447.383 565.945 436.867 553.624 430 539.655 430 516.644 430 498 448.594 498 471.543 498 474.795 498.417 477.939 499.123 480.975 504.903 516.808 544.855 554.628 573.5 565 602.127 554.628 642.097 516.808 647.859 480.975 648.583 477.939 649 474.795 649 471.543Z",
    fill: "#DD2E44",
    fillRule: "evenodd",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessory43);
export default __webpack_public_path__ + "static/media/accessory4-3.b0e3aa010a35fb9a22764240807453e2.svg";
export { ForwardRef as ReactComponent };